import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Moment } from 'moment'
import styled from 'styled-components'

import TabContentTitle from 'pages/HehmDevice/TabContentTitle'
import LastUpdatedText from 'components/LastUpdatedText'

import AlertsHistory from 'pages/HehmDevice/Alerts/AlertsHistory'
import ActiveAlerts from 'pages/HehmDevice/Alerts/ActiveAlerts'
import HomeownerPanelHeaderNotification from 'pages/shared/HomeownerAlert/HomeownerPanelHeaderNotification'

import { useWebsocketContext } from 'hooks/WebsocketContext'
import { useFeaturesContext } from 'hooks/FeaturesContext'

import { sortBasedOnSeverity, updateAlertsSeverity } from 'helpers/alerts'

import { color } from 'styles/colors'

type Props = {
  showDayRthCallback: (day: Moment) => void
  deviceTimeZone: string
}

const Alerts = ({ showDayRthCallback, deviceTimeZone: timeZoneProp }: Props) => {
  const { deviceId } = useParams()

  const { enabledFeatures } = useFeaturesContext()
  const isWebsocketEnabled = enabledFeatures.includes('montblanc_websockets')
  const {
    subscribe,
    unsubscribe,
    payload: wsReport
  } = useWebsocketContext(deviceId, 'alerts')

  useEffect(() => {
    if (isWebsocketEnabled) {
      subscribe(deviceId, 'alerts')
    }

    return () => {
      if (isWebsocketEnabled) {
        unsubscribe(deviceId, 'alerts')
      }
    }
  }, [deviceId, isWebsocketEnabled, subscribe, unsubscribe])

  const alerts = updateAlertsSeverity(wsReport?.alerts || [])
  const lastUpdatedAt = wsReport?.lastUpdatedAt
  const deviceTimeZone = timeZoneProp || 'UTC'

  sortBasedOnSeverity(alerts)

  return (
    <>
      <TabContentTitle>Alerts ({alerts?.length || 0})</TabContentTitle>
      <HomeownerPanelHeaderNotification />
      <LastUpdatedText timestamp={lastUpdatedAt} />
      <ActiveAlerts alerts={alerts} showDayRthCallback={showDayRthCallback} />
      <S.Divider />
      {deviceId && <AlertsHistory deviceId={deviceId} deviceTimeZone={deviceTimeZone} showDayRthCallback={showDayRthCallback} />}
    </>
  )
}

export default Alerts

const S = {
  Divider: styled.hr`
    margin: 24px 0;
    color: ${color('borderGray')};
  `
}
